<template>
  <b-card no-body>
    <b-card-header class="email-detail-head">
      <!-- Header -->
      <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
        <!-- Imagen representativa -->
        <b-media-aside class="media-left mr-50">
          <b-media no-body>
            <b-avatar
              variant="light-secondary"
              size="48"
            >
              <b-img
                width="22"
                :src="require('@/assets/images/icons/speaker.svg')"
              />
            </b-avatar>
          </b-media>
        </b-media-aside>

        <div class="mail-items">
          <!-- Título -->
          <h5 class="mb-0">
            {{ item.titulo }}
          </h5>
          <!-- Más detalles -->
          <b-dropdown
            v-if="item.visto || item.expira"
            variant="link"
            no-caret
            toggle-class="p-0"
            class="email-info-dropup"
          >
            <template #button-content>
              <span class="font-small-3 text-muted mr-25">Más detalles</span>
              <feather-icon
                icon="ChevronDownIcon"
                size="10"
              />
            </template>
            <table
              class="table table-sm table-borderless font-small-3"
              style="width: max-content;"
            >
              <tbody v-if="item.visto || item.expira">
                <tr v-if="item.visto">
                  <td class="text-right text-muted align-top pr-0">
                    Visto:
                  </td>
                  <td>{{ timestampToDate(item.visto, 'LLL') }}</td>
                </tr>
                <tr v-if="item.expira">
                  <td class="text-right text-muted align-top pr-0">
                    Expira:
                  </td>
                  <td>{{ timestampToDate(item.expira, 'LL') }}</td>
                </tr>
              </tbody>
            </table>
          </b-dropdown>
        </div>
      </div>
      <!-- Fecha -->
      <div class="mail-meta-item d-flex align-items-center">
        <small class="mail-date-time text-muted">{{ timestampToDate(item.fecha, 'LLLL') }}</small>
      </div>
    </b-card-header>

    <!-- Mensaje -->
    <b-card-body class="mail-message-wrapper pt-2">
      <!-- eslint-disable vue/no-v-html -->
      <div
        class="mail-message"
        v-html="item.mensaje"
      />
      <!-- eslint-enable -->
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BDropdown,
  BCard,
  BCardHeader,
  BCardBody,
  BAvatar,
  BMediaAside,
  BMedia,
  BImg,
} from 'bootstrap-vue'
import { timestampToDate } from '@core/utils/filter'

export default {
  components: {
    BDropdown,
    BCard,
    BCardHeader,
    BCardBody,
    BAvatar,
    BMediaAside,
    BMedia,
    BImg,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      timestampToDate,
    }
  },
}
</script>
